module.exports = __webpack_public_path__ + "img/activity-banner1-wap.4334d71f.png";